var lastScroll = 0;
let collStickyNav;
if(document.querySelector('.snippet-collection-filter')){
  collStickyNav = document.querySelector('.snippet-collection-filter').offsetTop;
}
window.addEventListener('scroll', (e)=>{
  let scrollCount = window.pageYOffset;
  document.querySelector('body').classList.add('solid_header');
  if(scrollCount == 0){
    document.querySelector('body').classList.remove('solid_header');
  }
  setTimeout(function(){
    if(scrollCount > lastScroll){
      document.querySelector('body').classList.remove('scroll-up');
      document.querySelector('body').classList.add('scroll-down');
    }else if(scrollCount < lastScroll){
      document.querySelector('body').classList.remove('scroll-down');
      document.querySelector('body').classList.add('scroll-up');
    }
    lastScroll = scrollCount;
  }, 0);
  let header = document.getElementById('shopify-section-header');
  if(scrollCount > header.offsetTop){
    header.classList.add('sticky_header');
  }
  if(scrollCount < document.getElementById('shopify-section-announcement-bar').clientHeight && document.querySelector('body').classList.contains('scroll-up')) header.classList.remove('sticky_header');
  if(document.querySelector('.snippet-collection-filter')){
    if(scrollCount > collStickyNav && document.querySelector('body').classList.contains('scroll-down')){
      document.querySelector('body').classList.add('active-coll-nav');
    }else if(document.querySelector('body').classList.contains('scroll-up')){
      document.querySelector('body').classList.remove('active-coll-nav');
    }
  }
})
let addAnim;
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu .mega-list').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      if(navList.matches(':hover')){
        let notActiveNav = navList.closest('.snippet-header-nav').querySelectorAll('.mega-list:not(.active)');
        notActiveNav.forEach(item => item.classList.remove('active-nav'));
        document.querySelector('body').classList.add('open-nav');
        document.querySelector('body').classList.remove('open-search','active-popup');
        document.querySelectorAll('.list-menu .mega-list').forEach(function(megaList){
          megaList.classList.remove('active');
        });
        navList.classList.add('active');
        clearInterval(addAnim);
        let items = navList.querySelectorAll('.mega-nav');
        let indexx = 0;
        function addedActiveNav(){
          items[indexx].classList.add('active-nav');
          indexx = (indexx + 1) % items.length;
        }
        addAnim = setInterval(addedActiveNav, 200);
      }
    }); 
    navList.addEventListener('mouseout', function(){
      if(!navList.matches(':hover')){
        clearInterval(addAnim);
        let items = navList.querySelectorAll('.mega-nav');
        items.forEach(item => item.classList.remove('active-nav'));
        document.querySelector('body').classList.remove('open-nav');
        navList.classList.remove('active');
      }
    });
  });
}
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter','active-popup');
    console.log('menu',document.querySelector('.mob-menuwrap').clientHeight+'px');
    if(document.querySelector('body').classList.contains('open-menu')){
      document.querySelector('.snippet-menu-drawer').style.height = document.querySelector('.mob-menuwrap').clientHeight+'px';
    }else{
      document.querySelector('.snippet-menu-drawer').style.height = '';
    }
  });
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','active-popup');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
let mob_arw_link = document.querySelectorAll('.mob-arw-link');
if(mob_arw_link) mob_arw_link.forEach(function(mb_link){
  mb_link.addEventListener('click',function(e){
    e.preventDefault();
    mb_link.closest('li').querySelector('.mob-second-level').classList.add('active');
    console.log('link',document.querySelector('.mob-menuwrap').clientHeight+'px');
    if(document.querySelector('body').classList.contains('open-menu')){
      document.querySelector('.snippet-menu-drawer').style.height = document.querySelector('.mob-menuwrap').clientHeight+'px';
    }else{
      document.querySelector('.snippet-menu-drawer').style.height = '';
    }
  });
});
let back_arrow = document.querySelectorAll('.back-arrow');
if(back_arrow) back_arrow.forEach(function(mb_close){
  mb_close.addEventListener('click',function(e){
    e.preventDefault();
    mb_close.closest('.mob-second-level').classList.remove('active');
    console.log('back',document.querySelector('.mob-menuwrap').clientHeight+'px');
    if(document.querySelector('body').classList.contains('open-menu')){
      document.querySelector('.snippet-menu-drawer').style.height = document.querySelector('.mob-menuwrap').clientHeight+'px';
    }else{
      document.querySelector('.snippet-menu-drawer').style.height = '';
    }
  });
});
document.querySelectorAll('.searchlist').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','open-wishlist','active-popup');
    setTimeout(() => {
      document.querySelector(".snippet-search-bar #Search").focus();
    },400);
  });
});
if(document.querySelectorAll('.search-close')){
  document.querySelectorAll('.search-close').forEach(function(searchClose){
    searchClose.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-search','open-mobile-search');
      resizeMenuDrawer();
    });
  });
};
document.addEventListener("DOMContentLoaded", (event) => {
  if(window.location.href.includes('a/wishlist')){
    document.querySelector('.wishlist').classList.add('active');
  }
});

// Add scroll to bottom functionality for disclosure buttons in mobile menu
document.querySelectorAll('.mob-menuwrap .disclosure__button').forEach(function(disclosureButton) {
  disclosureButton.addEventListener('click', function(e) {
    // Small delay to allow dropdown to open first
    setTimeout(() => {
      const menuDrawer = document.querySelector('.snippet-menu-drawer');
      if (menuDrawer) {
        // Scroll to the bottom of the menu drawer
        menuDrawer.scrollTo({
          top: menuDrawer.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 100);
  });
});